// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"wL-z","carouselContainer":"xL-z"};